export default __webpack_public_path__ + "static/media/cashless-payment.a1226e86.svg";